/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { FlatSubtenant } from '@/client';
import { useTheme } from '@/hooks/useTheme';
import { Avatar } from '@/primitives/Avatar';
import { Text } from '@/primitives/Text';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import { tokens } from '@/theme';

export type TenantOptionForSubtenantProps = {
  selectedSubtenant?: FlatSubtenant;
};

export function TenantOptionForSubtenant({ selectedSubtenant }: TenantOptionForSubtenantProps) {
  const theme = useTheme();
  const selectedTenantName = useMgmtPlaneStateStore((state) => state.selectedTenantName);

  // Show as selected if no subtenant is selected
  const isSelected = !selectedSubtenant;
  const color = isSelected
    ? { color: theme.antdComponents?.Menu?.itemSelectedColor }
    : { color: theme.antdComponents?.Menu?.itemColor };

  const tenantDisplayName = selectedTenantName || 'Tenant';
  const avatarText = tenantDisplayName.charAt(0).toUpperCase();

  return (
    <div style={{ display: 'flex', gap: 10, padding: '10px 0' }} data-testid="tenant-option-for-subtenant">
      <div style={{ flexGrow: 1, display: 'flex', gap: 10, overflow: 'hidden', maxWidth: '165px' }}>
        <Avatar
          size="xxs"
          text={avatarText}
          color={tokens.color.gold.gold03}
          backgroundColor={tokens.color.text.textSubtle}
          dataTestId="tenant-avatar"
          shape="square"
        />
        <Text data-testid="tenant-name" style={color} ellipsis>
          {tenantDisplayName}
        </Text>
      </div>
    </div>
  );
}
